import axios from 'axios';
import { getAccessToken, getUserToken } from 'services/auth';

const baseHeaders = {
  'Content-type': 'application/json',
  'Ocp-Apim-Subscription-Key': process.env.REACT_APP_APIM_KEY,
};

export const httpDelete = async <TResponse = unknown>(
  apiSubPath: string,
  isSecured = true,
  extraHeaders?: Record<string, unknown>,
) => {
  const url = `${process.env.REACT_APP_APIM_URL}/${apiSubPath}`;
  return axios.delete<TResponse>(url, {
    headers: {
      ...extraHeaders,
      ...baseHeaders,
      ...(isSecured ? { authorization: `Bearer ${getAccessToken()}`, CdsUserJwt: getUserToken() } : {}),
    },
  });
};
